import React from 'react'
import PortfolioFormContainer from './PortfolioFormContainer'

export default function PortfolioFormScreen() {
    return <PortfolioFormContainer />
}
